/** 직무별 skill_tags 선택지 (임시) — 직무별 표가 확정되면 이 표만 바꾼다 */
export const SKILL_TAGS = {
  planner: ['Problem definition', 'User research', 'Requirements', 'Prioritization', 'QA planning'],
  designer: ['UX flow', 'UI design', 'Design system', 'Prototyping', 'Design handoff'],
  developer: ['Frontend', 'Backend', 'API design', 'Testing', 'Deployment'],
  marketer: ['Messaging', 'Content', 'Growth', 'Market research'],
};
